// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67eaf4e0","455":"4aff6350","488":"1fb13b02"}[chunkId] + ".chunk.js";
};